<script>
export default {
    props: {
        padding: {
            type: Boolean,
            default: false,
        },
        overflow: {
            type: String,
            default: "auto",
        },
    },
    render(h) {
        return h('iframe', {
            on: { load: this.renderChildren }
        })
    },
    beforeUpdate() {
        // freezing to prevent unnessessary Reactifiation of vNodes
        if(this.iApp) {
            this.iApp.children = Object.freeze(this.$slots.default)
        }
    },
    methods: {
        renderChildren() {
            const children = this.$slots.default;
    
            var cssLink = document.createElement("link");
            cssLink.href = window.proposal_presentation_css; 
            cssLink.rel = "stylesheet"; 
            cssLink.type = "text/css"; 
            this.$el.contentDocument.head.appendChild(cssLink);

            const body = this.$el.contentDocument.body;
            const el = document.createElement('div') // we will mount or nested app to this element
            body.appendChild(el);

            if(this.padding) {
                body.style.padding = "6px";
            }
            if(this.overflow) {
                body.style.overflow = this.overflow;
            }

            const iApp = new Vue({
                name: 'iApp',
                // freezing to prevent unnessessary Reactifiation of vNodes
                data: { children: Object.freeze(children) }, 
                render(h) {
                    return h('div', this.children)
                },
            })
            iApp.$mount(el); // mount into iframe
            this.iApp = iApp; // cache instance for later updates

            this.$emit('loaded');
        },
    }
};
</script>
